<div class="profile-container">
  <div class="tabs">
    <button
      *ngFor="let tab of tabs; let i = index"
      [id]="tourTabIds[i]"
      (click)="setTab(i)"
      [class.active]="activeTab === i"
    >
      {{ tab | translate }}
    </button>
  </div>

  <!-- ===== TAB 0 — PROFILO ===== -->
  <app-load-error *ngIf="activeTab === 0 && loadError" (retry)="load()"></app-load-error>
  <div *ngIf="activeTab === 0 && !loadError">
    <!-- VISUALIZZA -->
    <div class="profile-card" *ngIf="!isEditOpen">
      <div class="avatar-wrapper">
        <div class="avatar-container" (click)="avatarInput.click()">
          <img
            *ngIf="user?.user?.avatar"
            [src]="user.user.avatar"
            class="avatar"
            alt="Avatar"
          />
          <div *ngIf="!user?.user?.avatar" class="avatar-placeholder">
            {{ user?.user?.name?.charAt(0)
            }}{{ user?.user?.lastname?.charAt(0) }}
          </div>
          <div class="avatar-overlay">
            <span>{{ "profile.change_avatar" | translate }}</span>
          </div>
        </div>
        <input
          #avatarInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="uploadAvatar($event)"
        />
        <span class="avatar-name"
          >{{ user?.user?.name }} {{ user?.user?.lastname }}</span
        >
        <span class="avatar-role">{{ attivity }}</span>
        <span class="avatar-email">{{ user?.user?.email }}</span>
      </div>

      <div class="divider"></div>

      <div class="stats">
        <div class="stat">
          <h3>{{ number_of_weddings }}</h3>
          <p>{{ "profile.weddings_count" | translate }}</p>
        </div>
        <div class="stat">
          <h3>{{ number_of_contracts }}</h3>
          <p>{{ "profile.contracts_count" | translate }}</p>
        </div>
      </div>

      <div class="divider"></div>

      <div class="info-box single" *ngIf="user?.user?.operating_area">
        <div class="info">
          <label>{{ "profile.operating_area_label" | translate }}</label>
          <p class="operating-area-value"><app-icon name="pin" [size]="14" /> {{ user.user.operating_area }}</p>
        </div>
      </div>

      <div class="action-row">
        <button class="btn-gold" (click)="isEditOpen = true">
          {{ "profile.edit_profile_btn" | translate }}
        </button>
        <button class="btn-logout" (click)="logout()">{{ "profile.logout_btn" | translate }}</button>
      </div>
    </div>

    <!-- MODIFICA PROFILO -->
    <div class="profile-card" *ngIf="isEditOpen">
      <h2 class="title">{{ "profile.edit_profile_btn" | translate }}</h2>
      <p class="contract-subtitle">{{ "profile.edit_profile_desc" | translate }}</p>
      <form [formGroup]="profileForm">
        <div class="info-box">
          <div class="info">
            <label>{{ "profile.fields.name" | translate }}</label>
            <input type="text" formControlName="name" />
          </div>
          <div class="info">
            <label>{{ "profile.fields.lastname" | translate }}</label>
            <input type="text" formControlName="lastname" />
          </div>
        </div>

        <div class="info-box">
          <div class="info">
            <label>{{ "profile.fields.email" | translate }}</label>
            <input type="email" formControlName="email" autocapitalize="off" />
          </div>
          <div class="info">
            <label>{{ "profile.fields.organization" | translate }}</label>
            <input type="text" formControlName="organization" />
          </div>
        </div>

        <div class="info-box single">
          <div class="info">
            <label>{{ "profile.operating_area_label" | translate }}</label>
            <input
              type="text"
              formControlName="operating_area"
              [placeholder]="'profile.operating_area_placeholder' | translate"
            />
            <small>{{ "profile.operating_area_hint" | translate }}</small>
          </div>
        </div>

        <div class="section-divider"><span>{{ "profile.professional_category_label" | translate }}</span></div>
        <div class="chip-group">
          <label *ngFor="let c of CATEGORIES" class="chip" [class.active]="hasCategory(c.value)" (click)="toggleCategory(c.value)">
            {{ c.label }}
          </label>
        </div>

        <div class="section-divider"><span>{{ "profile.change_password_label" | translate }}</span></div>
        <div class="info-box">
          <div class="info">
            <label>{{ "profile.new_password_label" | translate }}</label>
            <input
              type="password"
              formControlName="new_password"
              [placeholder]="'profile.leave_empty' | translate"
            />
          </div>
          <div class="info">
            <label>{{ "profile.confirm_password_label" | translate }}</label>
            <input type="password" formControlName="confirm_password" />
          </div>
        </div>

        <div class="buttons">
          <button type="button" class="btn-gold" (click)="saveProfile()">
            {{ "profile.save" | translate }}
          </button>
          <button type="button" class="btn-cancel" (click)="isEditOpen = false">
            {{ "profile.cancel" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- ===== TAB 1 — TEAM ===== -->
  <div *ngIf="activeTab === 1">
    <div class="contract-header">
      <div>
        <h2 class="contract-title">{{ "profile.access.title" | translate }}</h2>
        <p class="contract-subtitle">{{ "profile.access.desc" | translate }}</p>
      </div>
    </div>

    <!-- Form invito -->
    <div class="team-invite-form">
      <input
        type="email"
        [(ngModel)]="newTeamEmail"
        [placeholder]="'profile.access.email_placeholder' | translate"
        autocapitalize="off"
        (keyup.enter)="inviteTeamMember()"
      />
      <button class="btn-gold" (click)="inviteTeamMember()">{{ "profile.access.invite" | translate }}</button>
    </div>

    <app-load-error *ngIf="teamMembersError" (retry)="loadTeamMembers()"></app-load-error>

    <!-- Lista vuota -->
    <div
      class="contract-empty-banner"
      *ngIf="teamMembersLoaded && !teamMembersError && teamMembers.length === 0"
    >
      <div class="empty-icon"><app-icon name="users" [size]="36"></app-icon></div>
      <h3>{{ "profile.access.empty" | translate }}</h3>
      <p>{{ "profile.access.empty_desc" | translate }}</p>
    </div>

    <!-- Lista membri -->
    <div class="team-list" *ngIf="teamMembers.length > 0">
      <div *ngFor="let member of teamMembers" class="team-card">
        <div class="team-row">
          <div class="team-row-info">
            <span class="team-row-name">{{ teamMemberLabel(member) }}</span>
            <span class="team-row-role">{{ member.user?.email }}</span>
          </div>
          <div class="team-row-right">
            <span
              class="nyzed-status"
              [class.active]="member.user?.status === 'active'"
              [class.pending]="member.user?.status !== 'active'"
            >
              {{ (member.user?.status === 'active' ? "profile.access.active" : "profile.access.pending") | translate }}
            </span>
            <button
              *ngIf="member.user?.status !== 'active'"
              class="btn-text-small"
              (click)="resendTeamInvite(member)"
            >
              {{ "profile.access.resend" | translate }}
            </button>
            <button
              class="btn-text-small danger"
              (click)="removeTeamMemberAccess(member)"
            >
              {{ "profile.access.remove" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== TAB 2 — ASPETTO ===== -->
  <div *ngIf="activeTab === 2">
    <div class="contract-header">
      <div>
        <h2 class="contract-title">{{ "profile.theme.title" | translate }}</h2>
        <p class="contract-subtitle">{{ "profile.theme.subtitle" | translate }}</p>
      </div>
    </div>

    <div class="theme-grid">
      <div
        *ngFor="let p of themePresets"
        class="theme-card"
        [class.selected]="activeThemeId === p.id"
        [class.locked]="p.isPro && !canProAppearance"
        (click)="selectTheme(p)"
      >
        <div class="theme-swatch-bar" [style.background]="themeSwatchGradient(p)"></div>
        <span class="theme-name">
          {{ p.nameKey | translate }}
          <span *ngIf="p.isPro && !canProAppearance" class="pro-lock"><app-icon name="lock" [size]="12" /></span>
        </span>
        <span class="theme-desc">{{ p.descKey | translate }}</span>
      </div>
    </div>
  </div>

  <div class="version-footer">
  <a routerLink="/novita" class="version-link">
    Nyzed v{{ currentVersion }} — Novità
  </a>
</div>
</div>
